import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=7edeafc6&scoped=true"
import script from "./DashboardChart.vue?vue&type=script&lang=js"
export * from "./DashboardChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=7edeafc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edeafc6",
  null
  
)

export default component.exports